"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generatePayload;
var _utils = require("../../middleware/utils");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function calculateAge(day, month, year) {
  var dob = new Date(month + '/' + day + '/' + year);
  //calculate month difference from current date in time
  var diff_ms = Date.now() - dob.getTime();
  var age_dt = new Date(diff_ms);
  return Math.abs(age_dt.getUTCFullYear() - 1970);
}
function generatePayload(values, apiData) {
  var _apiData$data, _apiData$data2;
  var payload = {};

  /* istanbul ignore next */
  function setFieldIfExists(fieldName, value, forcedValue) {
    if (value !== '' && value !== undefined) {
      payload[fieldName] = value;
    } else if (forcedValue || forcedValue === 0) {
      payload[fieldName] = forcedValue;
    }
  }
  var baselineChildcareCost = apiData === null || apiData === void 0 || (_apiData$data = apiData.data) === null || _apiData$data === void 0 ? void 0 : _apiData$data.PV_Base_ChildCare_Cost[0];
  var baselineHealthcareCost = apiData === null || apiData === void 0 || (_apiData$data2 = apiData.data) === null || _apiData$data2 === void 0 ? void 0 : _apiData$data2.PV_Base_HealthCare_Cost[0];

  // Convert form strings to valid API fields
  var beneficiaryMap = {
    'just me': 'Just Me',
    'a dependent adult': 'Me & Spouse/Partner',
    'my spouse/partner': 'Me & Spouse/Partner',
    'my spouse/partner & kids': 'Me, Spouse/Partner & Kids',
    'my kids': 'Me & Kids'
  };
  var collegeTermMap = {
    'public 2-year': 'Public Two-Year In-District',
    'public 4-year in-state': 'Public Four-Year In-State',
    'public 4-year out-of-state': 'Public Four-Year Out-State',
    'private 4-year': 'Private Nonprofit Four-Year'
  };

  // Start all REQUIRED general fields
  setFieldIfExists('annualEarnedIncome', (0, _utils.parseCurrencyString)(null, values.annualPay));
  setFieldIfExists('burialCost', (0, _utils.parseCurrencyString)(null, values.burialCost));
  setFieldIfExists('currentAge', calculateAge(values.birthDay, values.birthMonth, values.birthYear));
  setFieldIfExists('earningsGrowthRate', (0, _utils.convertPercentageToRate)(values.earningsGrowthRate));
  setFieldIfExists('existingLifeInsurance', (0, _utils.parseCurrencyString)(null, values.existingLifeInsurance));
  setFieldIfExists('family', beneficiaryMap[values.beneficiary]);
  setFieldIfExists('healthCareRate', calculateRateFromCost(parseCurrencyIfNotBlankString(values.healthCareCost), baselineHealthcareCost, 10, parseFloatIfNotBlankString(values.healthCareCostUnrounded)));
  setFieldIfExists('incomeReplacementRate', (0, _utils.parseCurrencyString)(null, values.incomeReplacementRate));
  setFieldIfExists('inflationRate', (0, _utils.convertPercentageToRate)(values.inflationRate));
  setFieldIfExists('mortgage', (0, _utils.parseCurrencyString)(null, values.mortgageAmount));
  setFieldIfExists('numOfYearsReplacement', (0, _utils.parseCurrencyString)(null, values.numOfYearsReplacement));
  setFieldIfExists('otherDebt', (0, _utils.parseCurrencyString)(null, values.otherDebt));
  setFieldIfExists('personalExpenses', (0, _utils.convertPercentageToRate)(values.personalExpenses));
  setFieldIfExists('rateOfReturn', (0, _utils.convertPercentageToRate)(values.rateOfReturn));
  setFieldIfExists('retirementAge', (0, _utils.parseCurrencyString)(null, values.retirementAge));
  setFieldIfExists('savingAmount', (0, _utils.parseCurrencyString)(null, values.savingAmount));
  setFieldIfExists('useDefault', values.useDefault);
  setFieldIfExists('zip_code', values.zipCode);

  // Set all REQUIRED child related fields here
  setFieldIfExists('numOfChildren', (0, _utils.parseCurrencyString)(null, values.numOfKids));
  setFieldIfExists('childCareRate', calculateRateFromCost(parseCurrencyIfNotBlankString(values.childCareCost), baselineChildcareCost, 10, parseFloatIfNotBlankString(values.childCareCostUnrounded)));
  setFieldIfExists('collegeInflationRate', (0, _utils.convertPercentageToRate)(values.collegeInflationRate));
  setFieldIfExists('college1', 'None');
  if (isScenarioWithChildren(values.beneficiary)) {
    // Set all OPTIONAL child related fields in here
    setFieldIfExists('age1', (0, _utils.parseCurrencyString)(null, values.child1Age));
    setFieldIfExists('age2', (0, _utils.parseCurrencyString)(null, values.child2Age));
    setFieldIfExists('age3', (0, _utils.parseCurrencyString)(null, values.child3Age));
    setFieldIfExists('age4', (0, _utils.parseCurrencyString)(null, values.child4Age));
    setFieldIfExists('age5', (0, _utils.parseCurrencyString)(null, values.child5Age));
    setFieldIfExists('age6', (0, _utils.parseCurrencyString)(null, values.child6Age));
    setFieldIfExists('age7', (0, _utils.parseCurrencyString)(null, values.child7Age));
    setFieldIfExists('age8', (0, _utils.parseCurrencyString)(null, values.child8Age));
    setFieldIfExists('age9', (0, _utils.parseCurrencyString)(null, values.child9Age));
    setFieldIfExists('age10', (0, _utils.parseCurrencyString)(null, values.child10Age));
    if (isPlanningToFundChildsCollege(values.collegePlanInd, values.beneficiary)) {
      // Set all OPTIONAL college related fields for children
      for (var i = 1; i <= values.numOfKids; i++) {
        // college1 will minimally be set to "None"
        setFieldIfExists("college".concat(i), collegeTermMap[values.collegeTerm]);
      }
    }
  }

  // Set all REQUIRED related fields for spouse
  // If spouseIncome is not a number then set spouseIncome on payload as 0
  // (i.e. Initally said 'just me', went into modal, selected 'my spouse' then deleted the value and went back to 'just me')
  setFieldIfExists('spouseIncome', isNaN((0, _utils.parseCurrencyString)(null, values.spouseIncome)) ? 0 : (0, _utils.parseCurrencyString)(null, values.spouseIncome));
  // Specific note for the field below as we are handling spouseAge uniquely
  // We must set it to 0 as it is a required field, even when the scenario does not deal with spouse or dependent
  // This way even if niether of the if conditions below trigger, we know our required field is populated
  setFieldIfExists('spouseAge', 0);
  if (isScenarioWithSpouse(values.beneficiary)) {
    setFieldIfExists('spouseAge', (0, _utils.parseCurrencyString)(null, values.partnerAge), 0);
  }

  // No REQUIRED fields for dependentAge
  if (isScenarioWithDependent(values.beneficiary)) {
    setFieldIfExists('spouseAge', (0, _utils.parseCurrencyString)(null, values.dependentAge), 0);
  }
  return payload;
}

// Determines if the 'beneficiary' formik value is including kids
function isScenarioWithChildren(family) {
  return family == 'my kids' || family == 'my spouse/partner & kids';
}
function isScenarioWithSpouse(family) {
  return family == 'my spouse/partner' || family == 'my spouse/partner & kids';
}
function isScenarioWithDependent(family) {
  return family == 'a dependent adult';
}
function isPlanningToFundChildsCollege(planInd, beneficiary) {
  return planInd == 'plan' && isScenarioWithChildren(beneficiary);
}

// Returns a percentage of how big the first param is compared to the second param, in percent
function calculateRateFromCost(newCost, baseCost, precision, unroundedNewCost) {
  // If we are using the saved down PV_Base_Childcare_Cost, we want to use the unrounded value so rate = 100
  if (unroundedNewCost && unroundedNewCost.toFixed(0) == newCost) {
    newCost = unroundedNewCost;
  }
  if (newCost === '') {
    return 100;
  } else if (baseCost === 0) {
    if (newCost === 0) {
      return 0;
    } else {
      return 100;
    }
  }
  return _lodash.default.round(newCost * 100.0 / baseCost, precision);
}
function parseCurrencyIfNotBlankString(value) {
  if (isNaN((0, _utils.parseCurrencyString)(null, value))) {
    return value;
  }
  return (0, _utils.parseCurrencyString)(null, value);
}
function parseFloatIfNotBlankString(value) {
  if (isNaN(parseFloat(value))) {
    return value;
  }
  return parseFloat(value);
}